export const ITEM_WIDTH = 56;
export const GAP = 24;
export const ACTIVEBAR_OFFSET = 76;
export const SCROLL_TIMEOUT_MS = 150;
